// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"dropdownSelect_dropdown__Tykjh","text":"dropdownSelect_text__8aoPP","dropdownButton":"dropdownSelect_dropdownButton__60qTM","icon":"dropdownSelect_icon__3ZYrI"};